import { saveOrShareBlob } from '@/lib/native/save-document';
import { readFailure } from '@/lib/errors/response';

/**
 * A Download button under one of Mucka's replies (`export_records`).
 *
 * Not a navigation: the router cannot open a file, an Android WebView does
 * nothing with one, and opening it in a new window lands on the login wall in
 * Safari (save-document.ts has the whole story). So the bytes are fetched over
 * this session and handed to the device: a download on the web, the share
 * sheet in the app.
 *
 * Returns null when the file was handed over, or a failure for
 * `useReportFailure` carrying the route's own words — "No client matches
 * 'Smyth'" is something they can act on; "Download failed" is not (#35).
 *
 * Its own directive-free module because both chat surfaces call it
 * (anti-pattern #18).
 */
export async function downloadChatFile(
  path: string,
  filename: string,
): Promise<{ status: number; body?: unknown; fallback: string; request?: string } | null> {
  const request = `GET ${path.split('?')[0]}`;
  let res: Response;
  try {
    res = await fetch(path, { credentials: 'same-origin' });
  } catch {
    return { status: 0, fallback: "Couldn't reach Mucka. Check your connection and try again.", request };
  }
  if (!res.ok) return readFailure(res, "Couldn't make that spreadsheet just now.", request);
  const saved = await saveOrShareBlob(await res.blob(), filename);
  return saved ? null : { status: 0, fallback: "Couldn't save the spreadsheet on this device. Try again.", request };
}
